import CurrencyTypeList from '../components/currencytype/List.vue';
import CurrencyTypeCreate from '../components/currencytype/Create.vue';
import CurrencyTypeUpdate from '../components/currencytype/Update.vue';
import CurrencyTypeShow from '../components/currencytype/Show.vue';
import FileTypeList from '../components/filetype/List.vue';
import FileTypeCreate from '../components/filetype/Create.vue';
import FileTypeUpdate from '../components/filetype/Update.vue';
import FileTypeShow from '../components/filetype/Show.vue';
import TransferTypeList from '../components/transfertype/List.vue';
import TransferTypeCreate from '../components/transfertype/Create.vue';
import TransferTypeUpdate from '../components/transfertype/Update.vue';
import TransferTypeShow from '../components/transfertype/Show.vue';
import CompanyUpdate from '../components/company/Update.vue';
import CompanyShow from '../components/company/Show.vue';
import InvoicePaymentTypeList from '../components/invoicepaymenttype/List.vue';
import InvoicePaymentTypeCreate from '../components/invoicepaymenttype/Create.vue';
import InvoicePaymentTypeUpdate from '../components/invoicepaymenttype/Update.vue';
import InvoicePaymentTypeShow from '../components/invoicepaymenttype/Show.vue';
import InvoiceTaxTypeList from '../components/invoicetaxtype/List.vue';
import InvoiceTaxTypeCreate from '../components/invoicetaxtype/Create.vue';
import InvoiceTaxTypeUpdate from '../components/invoicetaxtype/Update.vue';
import InvoiceTaxTypeShow from '../components/invoicetaxtype/Show.vue';

const settingsTemplate = { template: '<router-view></router-view>' }
export default [
    { 
        path: '/settings',
        name: 'settings',
        redirect: { name: 'CurrencyTypeList' },
        component: settingsTemplate,
        children: [
            { name: 'CurrencyTypeList', path: 'currency_types/', component: CurrencyTypeList },
            { name: 'CurrencyTypeCreate', path: 'currency_types/create', component: CurrencyTypeCreate },
            { name: 'CurrencyTypeUpdate', path: 'currency_types/update/:id', component: CurrencyTypeUpdate },
            { name: 'CurrencyTypeShow', path: 'currency_types/show/:id', component: CurrencyTypeShow },
            { name: 'FileTypeList', path: 'file_types/', component: FileTypeList },
            { name: 'FileTypeCreate', path: 'file_types/create', component: FileTypeCreate },
            { name: 'FileTypeUpdate', path: 'file_types/update/:id', component: FileTypeUpdate },
            { name: 'FileTypeShow', path: 'file_types/show/:id', component: FileTypeShow },
            { name: 'InvoicePaymentTypeList', path: 'invoice_payment_types/', component: InvoicePaymentTypeList },
            { name: 'InvoicePaymentTypeCreate', path: 'invoice_payment_types/create', component: InvoicePaymentTypeCreate },
            { name: 'InvoicePaymentTypeUpdate', path: 'invoice_payment_types/update/:id', component: InvoicePaymentTypeUpdate },
            { name: 'InvoicePaymentTypeShow', path: 'invoice_payment_types/show/:id', component: InvoicePaymentTypeShow },
            { name: 'InvoiceTaxTypeList', path: 'invoice_tax_types/', component: InvoiceTaxTypeList },
            { name: 'InvoiceTaxTypeCreate', path: 'invoice_tax_types/create', component: InvoiceTaxTypeCreate },
            { name: 'InvoiceTaxTypeUpdate', path: 'invoice_tax_types/update/:id', component: InvoiceTaxTypeUpdate },
            { name: 'InvoiceTaxTypeShow', path: 'invoice_tax_types/show/:id', component: InvoiceTaxTypeShow },
            { name: 'TransferTypeList', path: 'transfer_types/', component: TransferTypeList },
            { name: 'TransferTypeCreate', path: 'transfer_types/create', component: TransferTypeCreate },
            { name: 'TransferTypeUpdate', path: 'transfer_types/update/:id', component: TransferTypeUpdate },
            { name: 'TransferTypeShow', path: 'transfer_types/show/:id', component: TransferTypeShow },
            { name: 'CompanyUpdate', path: 'company/update', component: CompanyUpdate },
            { name: 'CompanyShow', path: 'company/show', component: CompanyShow }
        ]
    }
];



// WEBPACK FOOTER //
// ./src/routes/settings.js